import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=78b8c139"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"
import style0 from "./TiptapEditor.vue?vue&type=style&index=0&id=78b8c139&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports